module.exports = __webpack_public_path__ + "static/highway-teal-a7b2498a53f80a785fc5ae545febc60a.png";